export default __webpack_public_path__ + "static/instagram.navy-1bf88207fcaeb969d919fa28f9342823.svg";